import React, { FC, FunctionComponent, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { GoogleOAuthProvider } from '@react-oauth/google';
import Loader from 'src/components/widgets/loader';
import NotFoundPage from '../components/pages/_notFound';
import config from '../shared/config';
import { Center } from '../shared/globals';
import { backofficeUrl, routeMatchUrl } from '../shared/helpers';
import routesToLogin from '../shared/routesToLogin';
import { AuthLayoutContainer } from './authLayoutContainer';

const AuthLayout: FunctionComponent<{ children?: React.ReactNode }> = () => {
    const currentRoute = window.location.pathname;
    if (currentRoute.toLowerCase().includes('user_login') && config.token) {
        config.token = '';
    }

    if (config.token) {
        window.location.href = `${backofficeUrl('/dashboard')}`;
        return null;
    }

    return (
        <GoogleOAuthProvider clientId={config.googleLoginClientID}>
            <Suspense
                fallback={
                    <Center>
                        <Loader />
                    </Center>
                }
            >
                <AuthLayoutContainer>
                    <Routes>
                        {routesToLogin.map((route, index) => {
                            return (
                                <Route key={index} path={routeMatchUrl(backofficeUrl(route.url))} element={React.createElement(route.component as FC<{}>)} />
                            );
                        })}
                        <Route path='*' element={<NotFoundPage />} />
                    </Routes>
                </AuthLayoutContainer>
            </Suspense>
        </GoogleOAuthProvider>
    );
};

export default AuthLayout;
